// src/App.js
import React from 'react';
import CompletePlanningApp from './components/CompletePlanningApp';
import './App.css';

function App() {
  return (
    <div className="App">
      <CompletePlanningApp />
    </div>
  );
}

export default App;